export default __webpack_public_path__ + "static/media/clipart.4a835dfe.png";